<template>
  <section class="app-main" :class="{'table-fullscreen':tableFullscreen}">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    tableFullscreen() {
      return this.$store.state.app.tableFullscreen
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar+50= header  */
  min-height: calc(100vh - 100px);
  width: 100%;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.table-fullscreen{
  z-index: 1002;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view + header = 50 + 34 + 50 */
    min-height: calc(100vh - 134px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
